import { render } from "./B2bTableMenuOcrDocuments.vue?vue&type=template&id=7d51861e&scoped=true&lang=pug"
import script from "./B2bTableMenuOcrDocuments.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuOcrDocuments.vue?vue&type=script&lang=js"

import "./B2bTableMenuOcrDocuments.vue?vue&type=style&index=0&id=7d51861e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d51861e"]])

export default __exports__